// src/_50_index_per.js
import React, { useState } from "react";
import axios from "axios";

export default function IndexPerCapture({ onCapture }) {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    () => {
      const d = new Date();
      d.setDate(d.getDate() - 1);
      return d.toISOString().slice(0, 10);
    }
  );

  // Helper to get last 7 trading days (Mon-Fri)
  function getLastNTradingDays(n) {
    const days = [];
    let d = new Date();
    d.setDate(d.getDate() - 1); // Start from yesterday
    while (days.length < n) {
      if (d.getDay() !== 0 && d.getDay() !== 6) {
        days.push(d.toISOString().slice(0, 10));
      }
      d.setDate(d.getDate() - 1);
    }
    return days.reverse(); // Oldest to newest
  }

  // Check DB for existing records for a list of dates
  async function checkExistingRecords(dates) {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/index_per/check_exists`,
        { trade_dates: dates },
        { withCredentials: true }
      );
      // Expects: { ok: true, exists: { "YYYY-MM-DD": true/false, ... } }
      return res.data.exists || {};
    } catch (err) {
      // If check fails, assume nothing exists (fail open)
      return {};
    }
  }

  // 1 Day retrieval
  const handleCaptureOneDay = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/index_per/capture_day`,
        { trade_date: selectedDate },
        { withCredentials: true }
      );
      setResult(res.data.data);
      if (onCapture) onCapture(res.data.data);
    } catch (err) {
      setError(
        (err.response && err.response.data && err.response.data.error) ||
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Error capturing 1 day"
      );
    } finally {
      setLoading(false);
    }
  };

  // 7 Day retrieval (calls new backend endpoint)
  const handleCaptureLast7Days = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/index_per/capture_last7`,
        {},
        { withCredentials: true }
      );
      setResult(res.data);
      if (onCapture) onCapture(res.data);
    } catch (err) {
      setError(
        (err.response && err.response.data && err.response.data.error) ||
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Error capturing last 7 days"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCaptureYTD = async () => {
    setLoading(true);
    setError(null);
    setResult(null);
    try {
      console.debug("Sending request to /api/index_per/capture_ytd", {
        url: `${process.env.REACT_APP_API_URL}/api/index_per/capture_ytd`,
      });

      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/index_per/capture_ytd`,
        {},
        { withCredentials: true }
      );

      console.debug("Received response from /api/index_per/capture_ytd", res);

      setResult(res.data.data);
      if (onCapture) onCapture(res.data.data);
    } catch (err) {
      console.error("Error in handleCaptureYTD:", err);
      setError(
        (err.response && err.response.data && err.response.data.error) ||
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Error capturing YTD"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ margin: "1em 0" }}>
      <h3>SPY Index Capture</h3>
      <div style={{ marginBottom: 8 }}>
        <input
          type="date"
          value={selectedDate}
          onChange={e => setSelectedDate(e.target.value)}
          disabled={loading}
          style={{ marginRight: 8 }}
        />
        <button onClick={handleCaptureOneDay} disabled={loading}>
          Capture 1 Day
        </button>
      </div>
      <button onClick={handleCaptureLast7Days} disabled={loading}>
        Capture Last 7 Days
      </button>
      <button
        onClick={handleCaptureYTD}
        disabled={loading}
        style={{ marginLeft: 8 }}
      >
        Capture YTD
      </button>
      {loading && <div>Loading...</div>}
      {error && <div style={{ color: "red" }}>{error}</div>}
      {result && (
        <div style={{ marginTop: 10 }}>
          <b>Captured:</b>
          <pre
            style={{
              background: "#222", // updated to dark gray
              color: "#fff",      // ensure text is readable on dark background
              padding: 8,
              borderRadius: 4,
            }}
          >
            {JSON.stringify(result, null, 2)}
          </pre>
        </div>
      )}
    </div>
  );
}